import React, { Fragment } from "react";
import { Navigate } from "react-router-dom";
import "./protected.scss";
import Header from "./components/header/header"

const ProtectedRoute = ({ features, children }) => {
  const isAuthenticated = localStorage.getItem("token") ? true : false;

  return isAuthenticated ? (
    <>
      <div>
        <div>
          <Header features={features}></Header>
          {children}
        </div>
        
      </div>
    </>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
